module.exports = __webpack_public_path__ + "e9778000b71a6c3a2e2259ff19fca9b7.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/welcome-images/images/welcome-diamond-pattern-left@2x.png
// module id = 790
// module chunks = 0